export const userRoles = {
    laboratorist: 'Laboratorista',
    technicalAdvisor: 'Asesor Técnico',
    coordinator: 'Coordinador',
};